














import { Component, Vue } from 'vue-property-decorator';
import Signin from '@/components/common/Signin.vue';
import TitleContainer from '@/components/common/TitleContainer.vue';
import { MetaInfo } from 'vue-meta/types/vue-meta';
import { pageSEO } from '@/utils/seo';
import seoDefault from '@/utils/seo-default';

@Component({
  components: {
    Signin,
    TitleContainer,
  },
  metaInfo(this: SigninPage): MetaInfo {
    return {
      title: pageSEO.title.signin,
      link: [
        {
          vmid: 'canonical',
          rel: 'canonical',
          href: pageSEO.canonical.signin,
        },
      ],
      meta: [
        ...seoDefault({
          title: pageSEO.titleMeta.signin,
          description: pageSEO.description.signin,
        }),
      ],
    };
  },
})
export default class SigninPage extends Vue {
  mainTitle = [
    {
      type: 'highlight',
      value: 'Sign',
    },
    {
      type: 'normal',
      value: 'in',
    },
  ];

  mainP = ``;
}
